import { useState, useEffect } from 'react';
import api from '../services/api/axiosConfig';

interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

const useCurrentUser = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }
      
      try {
        const response = await api.get('/auth/whoami');
        setUser(response.data.data);
      } catch (error) {
        console.error('Failed to get user:', error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    
    fetchUser();
  }, []);
  
  return { user, loading, userId: user?.id };
};

export default useCurrentUser;

